export default "__VITE_ASSET__DKuQyTUs__"